export const CLASS_CODES_PATH = '/admin/class-codes';
export type ClassCodeStatusFilter = 'active' | 'archived' | 'all';
export type ClassCodeSubjectFilter =
  | 'all'
  | 'mathematics'
  | 'english'
  | 'chemistry';
export interface ClassCodesListParams {
  status: ClassCodeStatusFilter;
  subject?: ClassCodeSubjectFilter;
  q: string;
}

export function parseClassCodesListParams(
  params: URLSearchParams
): ClassCodesListParams {
  const status = params.get('status');
  const subject = params.get('subject');
  return {
    status: status === 'archived' || status === 'all' ? status : 'active',
    subject:
      subject === 'mathematics' ||
      subject === 'english' ||
      subject === 'chemistry'
        ? subject
        : 'all',
    q: (params.get('q') ?? '').trim().slice(0, 200),
  };
}

export function classCodesListSearch(filters: ClassCodesListParams): string {
  const params = new URLSearchParams();
  if (filters.status !== 'active') params.set('status', filters.status);
  if (filters.subject && filters.subject !== 'all') {
    params.set('subject', filters.subject);
  }
  const q = filters.q.trim().slice(0, 200);
  if (q) params.set('q', q);
  return params.toString();
}

export function classCodesReturnTo(filters: ClassCodesListParams): string {
  const search = classCodesListSearch(filters);
  return `${CLASS_CODES_PATH}${search ? `?${search}` : ''}`;
}
